import { useFeatureValue } from '@shared/core/featureFlags';
import { getMostDiscountedActiveSale, isValidSalesPayload } from '@shared/utils/promotions';
import type { Sale } from '@shared/utils/promotions';

/**
 * Reads the live stationery sale config (`printSaleCodeV2`) and returns the
 * currently-running headline sale — the active (non-expired) sale with the
 * highest discount, category-agnostic. Powers the dynamic promo code shown in
 * the publish-time cross-sell modal so it always reflects whatever sale is
 * running in the stationery gallery. Returns undefined when no sale is active.
 */
export const useCurrentStationerySale = (): Sale | undefined => {
  const { payload } = useFeatureValue('printSaleCodeV2');
  const sales = isValidSalesPayload(payload) ? payload : null;
  return getMostDiscountedActiveSale(sales);
};
